<template>
    <v-form v-model="valid">

        <v-text-field 
            class="pb-3"
            :rules="required" 
            v-model="user.old_password" 
            label="Huidig wachtwoord*" 
            type="password" 
            required>
        </v-text-field>    

        <v-text-field 
            :rules="rules" 
            v-model="user.new_password" 
            label="Nieuw wachtwoord*" 
            type="password" 
            hint="Minimaal acht karakters, één hoofdletter, één speciaal teken"
            required>
        </v-text-field>

        <v-text-field 
            :rules="[passwordConfirmationRule]" 
            v-model="user.check_password" 
            label="Herhaal wachtwoord*" 
            type="password" 
            required>
        </v-text-field>

        <v-row justify="end">
            <v-btn 
                color="success" 
                rounded 
                :disabled="!valid" 
                @click="updatePassword()">
                Wachtwoord aanpassen</v-btn>
        </v-row>

    </v-form>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({
    valid: false,
    required: [v => !!v || "Verplicht veld"],
    rules: [
      v => !!v || "Verplicht veld",
      v =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
          v
        ) || "Minimaal acht karakters, één hoofdletter, één speciaal teken"
    ]
  }),
  computed: {
    ...mapState(["app", "user"]),
    passwordConfirmationRule() {
      return () =>
        this.user.new_password === this.user.check_password ||
        "Wachtwoorden zijn niet gelijk";
    }
  },
  methods: {
    updatePassword() {
      this.$store.dispatch("user/updatePassword", null, { root: true });
    }
  }
};
</script>
